import { render, staticRenderFns } from "./safetyGearDetail.vue?vue&type=template&id=50bd12bb"
import script from "./safetyGearDetail.vue?vue&type=script&lang=js"
export * from "./safetyGearDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50bd12bb')) {
      api.createRecord('50bd12bb', component.options)
    } else {
      api.reload('50bd12bb', component.options)
    }
    module.hot.accept("./safetyGearDetail.vue?vue&type=template&id=50bd12bb", function () {
      api.rerender('50bd12bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/sas/safetyGearDetail.vue"
export default component.exports